// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileReassignmentDto
 */
export interface IFileReassignmentDto {
    /**
     * 
     * @type {number}
     * @memberof IFileReassignmentDto
     */
    file_id: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof IFileReassignmentDto
     */
    pages?: Set<number>;
}

/**
 * Check if a given object implements the IFileReassignmentDto interface.
 */
export function instanceOfIFileReassignmentDto(value: object): value is IFileReassignmentDto {
    if (!('file_id' in value) || value['file_id'] === undefined) return false;
    return true;
}

export function IFileReassignmentDtoFromJSON(json: any): IFileReassignmentDto {
    return IFileReassignmentDtoFromJSONTyped(json, false);
}

export function IFileReassignmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileReassignmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_id': json['file_id'],
        'pages': json['pages'] == null ? undefined : new Set(json['pages']),
    };
}

export function IFileReassignmentDtoToJSON(json: any): IFileReassignmentDto {
    return IFileReassignmentDtoToJSONTyped(json, false);
}

export function IFileReassignmentDtoToJSONTyped(value?: IFileReassignmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_id': value['file_id'],
        'pages': value['pages'] == null ? undefined : Array.from(value['pages'] as Set<any>),
    };
}

